<div class="pnl-import-file" [class.inmodal]="inmodal">
  <strong>Importação manual</strong>
  <p>
    Importe o arquivo com a tabela de preços dos produtos do seu
    supermercado. A plataforma irá fazer a leitura dos dados e atualizará
    os preços no e-commerce.
  </p>

  <div class="exemplo">
    <strong>Exemplo da tabela: <small>campos obrigatórios: ean, descrição e preço</small></strong>
    <figure>
      <img src="assets/img/exemplo_excel.png">
    </figure>
  </div>

  <div
    ng2FileDrop
    [uploader]="uploader"
    (fileOver)="fileOverBase($event)"
    [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
    class="drag-zone-upload"
  >
    <div
      *ngIf="uploader.queue && uploader.queue.length > 0"
      class="file-cover"
    >
      <fa-icon [icon]="faFileImport"></fa-icon>

      <h6>Importar arquivo: {{ uploader.queue[0]._file.name }}</h6>
    </div>

    <input
      id="fileUploader"
      #fileUploader
      type="file"
      ng2FileSelect
      [uploader]="uploader"
      class="dnone"
    />

    <div>
      <button
        (click)="fileUploader.click()"
        type="button"
      >
        <fa-icon [icon]="faFileImport"></fa-icon>
        Procurar arquivo
      </button>
    </div>
  </div>

  <div *ngIf="actions" class="dflex frow mt20 mb20 jend">
    <button
      type="button"
      (click)="onCancelModalImport()"
      class="btn btn-cancel mr10"
    >
      Cancelar
    </button>
    <button
      type="button"
      (click)="onSendFile()"
      class="btn btn-primary"
      [disabled]="!changed"
    >
      <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
      Enviar arquivo
    </button>
  </div>
</div>
